import { Component } from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from 'ionic-angular';
import * as Highcharts from 'highcharts';

import { Location } from '../../models/location';
import { Data } from '../../providers/providers';
import { Thinning } from '../../providers/providers';
import { ThinningDataset } from '../../models/thinning-dataset';
import { ThinningDatasetEditPage } from '../thinning-dataset-edit/thinning-dataset-edit';
import { ThinningDatasetSummaryPage } from '../thinning-dataset-summary/thinning-dataset-summary';
import { AboutThinningPage } from "../about-thinning/about-thinning";
import { SprayRecord } from "../../models/spray-record";
import { Observable } from "rxjs/index";
import * as _ from "lodash";

@Component({
  selector: 'page-thinning-dataset-detail',
  templateUrl: 'thinning-dataset-detail.html'
})
export class ThinningDatasetDetailPage {

  location: Location;
  dataset: ThinningDataset;
  sprayRecords: Observable<SprayRecord[]>;

  Highcharts = Highcharts;

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController,
              private alertCtrl: AlertController,
              navParams: NavParams,
              public data: Data,
              public thinning: Thinning)
  {
    const self = this;
    this.location = navParams.get('location');
    this.dataset = navParams.get('dataset');

    this.thinning.setDataset(this.dataset, this.location);

    this.sprayRecords = data.getSprayRecordsCollection(this.location).valueChanges();
  }

  getStageLabel(stage) {
    return SprayRecord.stageLabels[stage];
  }

  editDataset() {
    let editModal = this.modalCtrl.create(ThinningDatasetEditPage, {dataset: this.dataset});

    editModal.onDidDismiss(dataset => {
      // dataset is not set if user cancelled modal
      if (dataset) {
        this.data.updateThinningDataset(dataset);
        // refresh dataset display
        this.dataset = dataset;
      }
    });
    editModal.present();
  }

  openAbout() {
    this.navCtrl.push(AboutThinningPage, {});
  }

  openSummary() {
    this.navCtrl.push(ThinningDatasetSummaryPage, {
      location: this.location,
      dataset: this.dataset
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/thinning-dataset-detail/thinning-dataset-detail.ts